import React from 'react'
import classNames from 'classnames'

import './square-widget.css'

const SquareWidget = (props) => {
  const { styles, children, className, onClick } = props
  const squareWidgetClasses = classNames('square-widget', className)

  return (
    <div
      className={squareWidgetClasses}
      style={styles}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export default SquareWidget
